import * as Scrivito from 'scrivito';
import React from 'react';
import { ReactComponent as IconSearch } from '../../../../../assets/icons/icon-search.svg';
import { ReactComponent as IconSearchDot } from '../../../../../assets/icons/icon-search-dot.svg';
import { ReactComponent as IconBurger } from '../../../../../assets/icons/icon-burger.svg';
import { NavigationAttributes, NavigationEntryAttrs } from '../../../../../pages/home-page/home-page-navigation';
import classNames from 'classnames';
import styles from './navigation-header.module.scss';
import { NavigationHeaderLink } from './navigation-header-link';
import { NavigationHeaderMeta } from './navigation-header-meta';
import { SearchAttributes } from '../../../../../pages/home-page/home-page-search';
import { useTranslation } from 'react-i18next';
import { LinkComponent } from '../../../link/link';
import { Logo } from '../../logo/logo';

interface NavigationHeaderProps {
  selected: Scrivito.Widget | undefined;
  small: boolean;
  onSelection: (selection: Scrivito.Widget | undefined) => void;
  onBurgerButton: () => void;
  burgerButtonRef?: React.RefObject<HTMLButtonElement>;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = Scrivito.connect(
  ({ selected, small, onSelection, onBurgerButton, burgerButtonRef }) => {
    const root = Scrivito.Obj.root();
    const navElements = (root?.get(NavigationAttributes.NAVIGATION) as Scrivito.Widget[]) ?? [];
    const selectedLabel = (selected?.get(NavigationEntryAttrs.LABEL) as string) ?? undefined;
    const searchPageLink = root?.get(SearchAttributes.SEARCH_PAGE) as Scrivito.Link;
    const logoVariant = root?.get(NavigationAttributes.LOGO_VARIANT) as string;
    const { t } = useTranslation();

    return (
      <>
        <NavigationHeaderMeta small={small} afterClick={(): void => onSelection(undefined)} />
        <div className={classNames(styles.NavigationHeader, { [styles.Small]: small })}>
          <div className={styles.LogoArea}>
            <LinkComponent to={root} accessibilityText={t('component.navigation.logoTitle')}>
              <Logo anniversary={logoVariant === 'anniversary'} />
            </LinkComponent>
          </div>
          <nav className={styles.LinksArea}>
            {navElements.map((element, index) => (
              <NavigationHeaderLink
                key={`nav-link-${index}`}
                element={element}
                selected={selectedLabel}
                small={small}
                setSelected={onSelection}
              />
            ))}
          </nav>
          <div className={styles.IconsArea}>
            <LinkComponent
              to={searchPageLink}
              className={styles.White}
              accessibilityText={t('component.navigation.searchButtonTitle')}
            >
              <IconSearch className={styles.NotHover} />
              <IconSearchDot className={styles.HoverOnly} />
            </LinkComponent>
            <button
              className={classNames(styles.White, styles.MobileOnly)}
              onClick={onBurgerButton}
              ref={burgerButtonRef}
              aria-label={t('component.navigation.menuButtonTitle')}
            >
              <IconBurger />
            </button>
          </div>
        </div>
      </>
    );
  }
);
